'use strict';

module.exports = require('wix-data-webmethod-structures');


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/ref.js
// module id = 176
// module chunks = 0